"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportRanks = void 0;
const ReportDisease_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/report/ReportDisease"));
const ReportPGP_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/report/ReportPGP"));
const ReportNutrientFunction_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/report/ReportNutrientFunction"));
class ReportRanks {
    constructor() {
        this.shi = null;
        this.biodiversity = 0;
        this.functionality = 0;
        this.resistance = 0;
        this.resilience = 0;
        this.healthiness = 0;
        this.biocontrol = 0;
        this.hormoneprod = 0;
        this.stressadapt = 0;
        this.nutrition_c = 0;
        this.nutrition_n = 0;
        this.nutrition_p = 0;
        this.nutrition_k = 0;
    }
}
exports.ReportRanks = ReportRanks;
class Report {
    constructor() {
        this.ranks = new ReportRanks();
        this.diseases = [];
        this.grow_promoters = [];
        this.nutrient_functions = [];
    }
    static fromRaw(raw) {
        const report = new Report();
        report.ranks.shi = raw.shi ? raw.shi.rank : null;
        report.ranks.biodiversity = +raw.biodiversity_rank;
        report.ranks.functionality = +raw.functionality_rank;
        report.ranks.resistance = +raw.resistance_rank;
        report.ranks.resilience = +raw.resilience_rank;
        report.ranks.healthiness = +raw.healthiness_rank;
        report.ranks.biocontrol = +raw.biocontrol_rank;
        report.ranks.hormoneprod = +raw.hormoneprod_rank;
        report.ranks.stressadapt = +raw.stressadapt_rank;
        report.ranks.nutrition_c = +raw.nutrition_c_rank;
        report.ranks.nutrition_n = +raw.nutrition_n_rank;
        report.ranks.nutrition_p = +raw.nutrition_p_rank;
        report.ranks.nutrition_k = +raw.nutrition_k_rank;
        if (raw.diseases) {
            report.diseases = raw.diseases.map((raw) => ReportDisease_1.default.fromRaw(raw));
        }
        if (raw.grow_promoters) {
            report.grow_promoters = raw.grow_promoters.map((raw) => ReportPGP_1.default.fromRaw(raw));
        }
        if (raw.nutrients) {
            raw.nutrients.forEach((rawNutrient) => {
                rawNutrient.functions.forEach((rawFunc) => {
                    const func = ReportNutrientFunction_1.default.fromRaw(rawNutrient, rawFunc);
                    report.nutrient_functions.push(func);
                });
            });
        }
        return report;
    }
}
exports.default = Report;
